const PROVIDERS = {
  PASSWORD: "password",
  GOOGLE: "google.com",
  MICROSOFT: "microsoft.com"
};

const PROVIDERS_TYPE = {
  GOOGLE: "google",
  MICROSOFT: "microsoft"
};

export { PROVIDERS, PROVIDERS_TYPE };
